import { AppConfig } from '../../models/config/app-config.type';

export const recaptchaOverrideTokenFactory = (
  config: AppConfig
): string | undefined => config.recaptchaOverrideToken;
